module.exports = __webpack_public_path__ + "img/w3_button_close_dark.4e3c2332.png";